import { render, staticRenderFns } from "./NewInvestment.vue?vue&type=template&id=57cc7f1e"
import script from "./NewInvestment.vue?vue&type=script&lang=js"
export * from "./NewInvestment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports